import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../Miscelania/RequestApi';

import { Link } from 'react-router-dom';
import Overlay from '../Miscelania/Overlay';
import DatePicker from 'react-datepicker';
import getLocale from '../../i18n/getLocale';

// Importação da tabela
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';

class FlightReportRefuelsRequestIndex extends Component {
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'open',
      },
      redirect_url: false,
      loaded: 0,
      selected_date: '',
      data: []
    };
    //Handlers
    this.handleAlert = this.handleAlert.bind(this);
    this.handleLoaded = this.handleLoaded.bind(this);
    this.handleMessage = this.handleMessage.bind(this);
    this.locale = getLocale();

    this.ActionsButtons = this.ActionsButtons.bind(this);
    this.loadData = this.loadData.bind(this);
    this.backgroundColor = this.backgroundColor.bind(this);
  }

  // Handlers
  handleAlert(message, type, status, mode) {
    if(mode === 'reset') {
      this.setState({overlay: {message: '', type: '', status: 'closed'}});
    } else {
      this.setState({overlay: {message: message, type: type, status: status}});
    }
  }


  handleLoaded(state) {
    if(this.state.loaded !== 2) {
      this.setState({loaded: state});
    }
  }

  handleMessage () {
    var message = localStorage.getItem("verify_message");
    if (message !== null && typeof message !== 'undefined') {
      message = JSON.parse(message);
      var self = this;
      self.setState({overlay: {message: message.alert_message, type: message.alert_type, status: 'open'}});
      localStorage.removeItem("verify_message");
    }
  }

  componentDidMount () {
    this.refs.request_api.header();
  }

  componentDidUpdate(prevProps, prevState) {
    if(this.state.loaded === 1 && prevState.loaded === 0) {
      this.setState({loaded: 2}, this.loadData());
    }
  }

  loadData() {
    var self = this;
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/solicitacoes/abastecimentos', { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url');
        if (responseJson.status === 'success') {
          self.setState({data: responseJson.data});
        }
      }).then(() => {
        self.setState({overlay: {message: '', type: '', status: 'closed'}});
        self.handleMessage();
      }); /* Overlay */
    });
  }

  delete (id) {
    var confirm = window.confirm('Tem certeza que gostaria de deletar essa solicitação de abastecimento?');
    if (confirm) {
      this.handleAlert('', '', 'open');
      var datasave = {
        id: id,
      };
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/solicitacao/abastecimento', { method: 'DELETE', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.refs.request_api.validate(responseJson, 'alert');
          if (responseJson.status === 'success') {
            self.deleteRow(id);
          }
          self.handleAlert(responseJson.message, responseJson.status, 'open');
        }).catch((error) => {
          console.error(error);
        });
      });
    }
  }

  deleteRow(id) {
    var data = this.state.data;
    data.map(function(dado, index){
      if (dado.id == id) {
        data.splice(index, 1);
      }
    });
    this.setState({data: data});
  }

  ActionsButtons (cell, row) {
    var url = '/abastecimento/solicitacao/editar/' + cell;

    var botao = (
      <div className="btn-group">
          <Link className={'btn btn-primary btn-sm button-inline'} to={url}>
            <i className="fa fa-fw fa-pencil"></i>
          </Link>
          <button className="btn btn-danger btn-sm button-inline" onClick={() => this.delete(cell)}><i className="fa fa-fw fa-trash"></i></button>
      </div>
    );

    return botao;
  }

  backgroundColor (cell, row) {
    if (row.time_since_created_in_minutes <= 15) {
      return <span className="label label-success">{cell}</span>;
    } else if (row.time_since_created_in_minutes <= 30) {
      return <span className="label label-warning">{cell}</span>;
    } else {
      return <span className="label label-danger">{cell}</span>;
    }
  }

  render() {
    return (
<div>
  <RequestApi ref={'request_api'} handleLoaded={this.handleLoaded} />
  <Overlay overlay={this.state.overlay} handleAlert={this.handleAlert} />
  <div className="container-liquid">
    <div className="conteudo">
      <h3 className="page-title pull-left">{this.locale.RelatorioAbastecimento.ListaDeAbastecimentos.solicitacoes}</h3>
      <Link to="/abastecimento/solicitar" className="btn btn-primary pull-right"><i className="fa fa-plus"></i> {this.locale.RelatorioAbastecimento.ListaDeAbastecimentos.adicionarSolicitacao}</Link>
      <div className="clearfix"></div>
      <hr/>
      <BootstrapTable data={this.state.data} pagination={true} striped={true} hover={true} exportCSV={true} options={{exportCSVText: this.locale.general.exportarTextoCSV, noDataText: this.locale.general.semDados}} search={true} multiColumnSearch={true}  searchPlaceholder={this.locale.general.procurar}>

        <TableHeaderColumn dataField="id" isKey={true} hidden={true} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}} width='60'>ID</TableHeaderColumn>

        <TableHeaderColumn dataField="id" dataAlign="center" dataFormat={this.ActionsButtons} width='100'>{this.locale.RelatorioAbastecimento.ListaDeAbastecimentos.tabela.Acoes}</TableHeaderColumn>
        
        <TableHeaderColumn dataField="date_str" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}} width='100'>{this.locale.RelatorioAbastecimento.ListaDeAbastecimentos.tabela.Data}</TableHeaderColumn>
        <TableHeaderColumn dataField="time_since_created" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}} dataFormat={this.backgroundColor} width='100'>{this.locale.RelatorioAbastecimento.ListaDeAbastecimentos.tabela.Criado}</TableHeaderColumn>
        {/* <TableHeaderColumn dataField="flight_report_id" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}} width='140'>{this.locale.RelatorioAbastecimento.ListaDeAbastecimentos.tabela.Relatório}</TableHeaderColumn> */}
        <TableHeaderColumn dataField="aircraft_registration" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}} width='120'>{this.locale.RelatorioAbastecimento.ListaDeAbastecimentos.tabela.Aeronave}</TableHeaderColumn>
        <TableHeaderColumn dataField="requested" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}} width='120'>{this.locale.RelatorioAbastecimento.ListaDeAbastecimentos.tabela.Solicitado}</TableHeaderColumn>
        <TableHeaderColumn dataField="location_icao_code" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}} width='120'>{this.locale.RelatorioAbastecimento.ListaDeAbastecimentos.tabela.Localidade}</TableHeaderColumn>
        <TableHeaderColumn dataField="fuel_supplier_name" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}} width='200'>{this.locale.RelatorioAbastecimento.ListaDeAbastecimentos.tabela.Fornecedor}</TableHeaderColumn>
        <TableHeaderColumn dataField="flight_number" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}} width='200'>{this.locale.RelatorioAbastecimento.ListaDeAbastecimentos.tabela.Voo}</TableHeaderColumn>
  
      </BootstrapTable>
    </div>
  </div>
</div>
    );
  }
}

export default FlightReportRefuelsRequestIndex;



// WEBPACK FOOTER //
// ./src/Components/FlightReportRefuels/FlightReportRefuelsRequestIndex.js